<div class="container display-layout-row layout-align-center-center">
  <mat-card class="login-card display-layout-column justify-content-center layout-gap-10">
    <div class="display-layout-column layout-align-start-start layout-gap-2">
      <h1>Welcome back to VR-Cargo</h1>
      <h3>Login to your account</h3>
    </div>
    <mat-card-content>
      <div [formGroup]="loginForm" class="display-layout-column layout-gap-5">
        <mat-form-field appearance="outline">
          <input
            matInput
            type="text"
            formControlName="username"
            placeholder="Username"
            />

          @if (loginForm.controls['username'].hasError('required')) {
            <mat-error
              >
              Username is <strong>required</strong>
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <input
            (keydown.enter)="loginUser()"
            matInput
            type="password"
            formControlName="password"
            placeholder="Password"
            (keydown.enter)="loginUser()"
            />
          @if (loginForm.controls['password'].hasError('required')) {
            <mat-error
              >
              Password is <strong>required</strong>
            </mat-error>
          }
        </mat-form-field>
      </div>
    </mat-card-content>

    <mat-card-actions class="justify-content-center">
      <div class="display-layout-column layout-align-center-center layout-gap-5">
        <button
          mat-stroked-button
          [disabled]="!loginForm.valid"
          (click)="loginUser()"
          >
          Login
        </button>
      </div>
    </mat-card-actions>
  </mat-card>
</div>
